import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { Settings } from '../shapes';


const SettingsSvg = (props) => (
  <g>
    <IconBounds />
    <Settings {...props} />
  </g>
);

SettingsSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

SettingsSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default SettingsSvg;
